module.exports = __webpack_public_path__ + "static/scale-model-of-the-great-escape-room-in-providence-rhode-island-cfe0d5a688507260a2ff4bc49e43fe8f.png";